import { ProductPurchaseModel } from 'api-hooks/product/order';
import * as Yup from 'yup';

// additional information
export const PicFormSchema = () =>
  Yup.object({
    name: Yup.string().default(''),
    phone: Yup.string().default(''),
    description: Yup.string().default(''),
    email: Yup.string().default(''),
  });

export const ProductPurchaseDetailFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    productVariantId: Yup.object({
      id: Yup.string().default(''),
      label: Yup.string().default(''),
    }),
    price: Yup.number().default(0),
    qty: Yup.number().default(0).min(1),
    description: Yup.string().default(''),

    //additional information
    customId: Yup.string().default(''),
  });

export const ProductPurchaseOtherFeesFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    name: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number().default(0),

    customId: Yup.string().default(''),
  });

export const ProductPurchaseFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    agentId: Yup.string().default(''),
    paymentChannelId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    commission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    productPurchases: Yup.array(ProductPurchaseDetailFormSchema()).default([]),
    productPurchaseOtherFees: Yup.array(
      ProductPurchaseOtherFeesFormSchema(),
    ).default([]),
    pic: PicFormSchema(),
    // additional information
    paymentChannelName: Yup.string().default(''),
  });

export type ProductPurchaseFormType = Yup.InferType<
  ReturnType<typeof ProductPurchaseFormSchema>
> & {
  orderNumber: string;
  agentStatus: string;
  productPurchase?: ProductPurchaseModel;
  tempTransactionAt: Date;
  remainingTransactionQuota: number | null;
  isExceedingQuota: boolean;
};

export type ProductPurchaseDetailFormType = Yup.InferType<
  ReturnType<typeof ProductPurchaseDetailFormSchema>
>;

export type ProductPurchaseOtherFeesFormType = Yup.InferType<
  ReturnType<typeof ProductPurchaseOtherFeesFormSchema>
>;

export type PicFormType = Yup.InferType<ReturnType<typeof PicFormSchema>>;
